import Icon from 'veui/components/Icon'
import { IconFile } from 'dls-icons-vue'

Icon.register('file', IconFile)
